export default require("./Color-Picker").default;
